/**
 * Before After
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
    el: '.before-after',

    events: {
        'input .before-after__slider': 'beforeAfterSliding',
        'change .before-after__slider': function (e) {
            this.beforeAfterSliding(e);
            this.logGTMEvent(e);
        },
    },

    beforeAfterSliding: function () {
        this.el.querySelector('.before-after__sliding-overlay').style.width = 'calc(' + this.el.querySelector('.before-after__slider').value + '% + 25px)';
    },

    logGTMEvent: function () {
        if (this.el.dataset.jsGtmData) {
            const { event, eventaction, eventcategory, eventlabel } = JSON.parse(this.el.dataset.jsGtmData);

            dataLayer.push({
                event,
                eventaction,
                eventcategory,
                eventlabel,
            });
        }
    }
});

export default View;
